export enum ProductSheetLanguages {
  FR = "FR",
  EN = "EN",
  NL = "NL",
  DE = "DE",
  IT = "IT",
  ES = "ES",
}

export type ProductSheetLanguage =
  (typeof ProductSheetLanguages)[keyof typeof ProductSheetLanguages]
